import React, { useEffect, useRef } from "react";
import Movie from "../../../assets/movies/slide1.mp4";

const Slide1 = ({ sliderRef }) => {
    const videoRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;
        if (video) {
            const handleEnded = () => {
                if (sliderRef.current) {
                    sliderRef.current.slickNext();
                }
            };
            video.addEventListener("ended", handleEnded);
            return () => {
                video.removeEventListener("ended", handleEnded);
            };
        }
    }, [sliderRef]);

    return (
        <div className="slide-1">
            <div className="generic-container">
                <video ref={videoRef} autoPlay className="background-video" data-mode="center" data-keepplaying="1" preload="auto" playsInline muted>
                    <source src={Movie} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </div>
        </div>
    );
}

export default Slide1;